import { render, staticRenderFns } from "./editAndDeleteGroup.vue?vue&type=template&id=504a39c8"
import script from "./editAndDeleteGroup.vue?vue&type=script&lang=js"
export * from "./editAndDeleteGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports